StepController = App.loadClass 'grower::Angular/Data/PlantingRx/StepController'

# TODO: service-ify some of this. There's a triceratops sized crapload
# of heavy logic in here, and this is getting *real* cluttery. Also none
# of this is easily reusable! I'm thinking there should be a service
# that manages rx data (rather than just the rx scope var), which can
# contain a lot of the special logic that goes on here.
#
class exports.PrescriptionController extends StepController
    constructor: (@scope, @transitions, @map, @state, @rxLayer, @visualLayers, @layerManager, @loader, @legend) ->
        super(@scope, @transitions, @map)
        return if @scope.aborted

        @scope.initializing = true
        @scope.options_changed = false
        @scope.recalculate = @recalculate
        @scope.averagePop = @rxLayer.averagePop
        @scope.toggleTable = @toggleTable
        @scope.checkPopMinMax = @checkPopMinMax
        @scope.checkPopDiffMinMax = @checkPopDiffMinMax
        # holds rows constructed for the legend
        @scope.legend_rows = []
        # tell the mf-post-repeat directive which event to emit
        @scope.event = 'rendered'

        @scope.can_recalc = true
        @scope.recalc_error = null
        @scope.recalc_error_type = null

        @scope.options =
            pop_diffs: [
                100, 500,
                1000, 1500,
                2000, 2500,
                3000, 3500,
                4000, 4500,
                5000
            ]
            num_pops: [2..30]

        # recalc has two properties: fetch and recalculate, depending what is needed
        recalc = @needsRecalc()

        # If there's no target yet, calculate one, or recalculate it if we need
        # to recalculate the rx
        if not @scope.rx.solver_variables.target? or recalc.recalculate
            load_msg = @loader.overMapAndSidebar 'Calculating Target Population...'
            target_promise = @rxLayer.calculateTargetPop()

            # handle errors
            target_promise.then (response) =>
                load_msg.hide()
                if response.status?.type is 'error'
                    # there was a known error. include message in the text
                    msg = "Failed to calculate Target Pop: #{response.status.msg}"
                    @scope.recalc_error = msg
                    @scope.recalc_error_type = 'error'
            .catch =>
                # there was an unhandled exception. show a generic message
                @scope.recalc_error = 'Failed to calculate Target Pop'
                @scope.recalc_error_type = 'error'

        # list of selected layer names
        @getVisualLayersList()

        # TODO: This could move to the Sidebar controler. That's where
        # we'll want to be watching for changes to force recalculation and
        # such anyway
        @scope.$watch 'rx.solver_variables', () =>
            if not @scope.initializing
                @scope.options_changed = true
        , true

        # When there are no populations, we can't save the rx layer. This
        # prevents clicking "save" if there was an error in the backend.
        @scope.$watch 'rx.populations', (val) =>
            if not val or val.length is 0
                @scope.$parent.setValidity false
            else if not @scope.rxForm.$invalid
                @scope.$parent.setValidity true

        recolor = () =>
            @popMapLayer.recolor() if @popMapLayer?
            # temporarily removed for https://www.pivotaltracker.com/story/show/177318692
            # @scope.legend_rows = @legend.constructRows()

            # update truth strip colors (normal rows update automatically
            # because the properties are passed by reference).
            for strip in @scope.rx.truth_strips
                polys = @rxLayer.getStripPolygons(strip)
                continue if not polys or polys.length is 0
                strip.fillColor = polys[0].fillColor

        # This is a deep watch, because we need to update populations in the
        # summary if the user changes anything in the table. Always recolor if
        # populations change or we get new populations (even if none changed).
        @scope.$watch 'rx.populations', () =>
            recolor()
            @calculateSummaries()
        , true

        @setUpMap()

        # legend temporarily removed for https://www.pivotaltracker.com/story/show/177318692
        # set up the legend
        # @scope.$on 'rendered', () =>
            # remove the previous version of the legend
            # @map.map.legendControl.removeLegend(@legendHTML)
            # cache the html to reference the legend
            # @legendHTML = @legend.getHTML()
            # ensure that we have rows before adding the legend
            # if @scope.legend_rows.length > 0
            #     @map.map.legendControl.addLegend(@legendHTML)
        # @scope.$on '$destroy', () =>
        #     @map.map.legendControl.removeLegend(@legendHTML)

        # If there's no population geometry, that means we
        # either haven't ever run the calculation, OR, we've
        # changed the underlying rx data, and the SidebarController
        # has cleared the list to force recalculation
        #
        # If we do have population data, we want to just re-display it
        if recalc.fetch
            # if we need to calculate the target pop, don't recalculate the rx
            # until we have the target pop.
            if target_promise?
                # use .success here instead of .then, because we don't want to
                # try to calculate the rx if the target pop fails
                target_promise.then (response) =>
                    if response.status?.type isnt 'error'
                        @recalculate(recalc.recalculate)
            else
                # otherwise, go ahead and recalculate the rx immediately
                @recalculate(recalc.recalculate)
        else
            @mapLayer.addLayer @scope.rx.populations_geom
            @setPopulationsFromGeom(@scope.rx.populations_geom)
            @scope.initializing = false


        @scope.$watch 'rxForm.$invalid', (val) =>
            @scope.can_recalc = not val
            @scope.$parent.setValidity(not val)
            # console.log "Form status:"
            # console.log val

    # TODO: make this a filter?
    # The frontend needs a nice comma separated list of layer names to display,
    # so we just iterate through the list of layers at the start and join them
    # to a pretty string
    getVisualLayersList: () =>
        layers = []
        for layer in @scope.rx.visual_layers
            layers.push layer.name

        @scope.visual_layers_list = layers.join(', ')


    # Recalculates populations, displays the geometry on the map.
    recalculate: (recalculate = true) =>
        options = @rxLayer.asSolverOptions()
        options.recalculate = false if not recalculate

        calculating = if @scope.rx.populations.length > 0 then 'Recalculating' else 'Calculating'
        load_msg = @loader.overMapAndSidebar "#{calculating}..."
        @scope.options_changed = false
        @scope.recalc_error = null
        @scope.recalc_error_type = null

        @mapLayer.clearLayers()

        @popMapLayer = @layerManager.get('PopulationMap')
        @popMapLayer.display(options, @mapLayer).then (response) =>
            @setPopulationsFromGeom response
            @scope.rx.previous_calculation = options
            @scope.initializing = false
            load_msg.hide()
        .catch (response) =>
            # Show an error message somehow...
            @scope.initializing = false
            @scope.options_changed = true
            @scope.rx.populations_geom = null
            @scope.rx.populations = []
            @scope.recalc_error = response.data.status?.msg
            @scope.recalc_error_type = response.data.status?.type
            load_msg.hide()

    # When we recalculate, all the populations come
    # back as geojson. This method converts geojson layers
    # into an array of attributes about each layer, including
    # population / acreage / etc.
    setPopulationsFromGeom: (response) =>
        @scope.rx.populations_geom = response
        @scope.rx.populations = []

        # Todo: Do we actually need to copy populations_geom
        # to populations? this is literally just a reformat of the
        # same data. We're directly yanking the feature properties object,
        # so it's a *reference*, not a new set of data, anyway. We could
        # just update references around the app to look at the feature
        # properties instead of making a new array of all the layers.
        for feat in response.getLayers()
            props = feat.feature.properties
            props.temp_population = props.population
            props.orig_population = parseInt props.population
            props.temp_hybrids_id = props.hybrids_id
            props.temp_hybrid_name = props.hybrid_name
            @scope.rx.populations.push props


    # Determine if we should fetch and/or recalculate. Cases:
    #
    #   - No populations_geom -> we need to fetch.
    #   - The calculate options have changed -> we need to recalculate
    #
    # This is checked when we first load up the prescription step
    # TODO: needsFetch should probably be a separate method
    needsRecalc: () =>
        fetch = false
        recalculate = true

        if not @scope.rx.populations?.length
            fetch = true

        comparison = @rxLayer.compareSolverOptions(@scope.rx.previous_calculation)

        if comparison
            recalculate = false
        else
            fetch = true

        return { fetch: fetch, recalculate: recalculate }


    # Calculates the weighted average population of the
    # individual area pops assigned
    # averagePop: () =>
    #     avg = 0
    #     total_acres = 0
    #     for pop in @scope.rx.populations
    #         acres = parseFloat(pop.acres)
    #         total_acres += acres
    #         avg += acres *  pop.population

    #     if total_acres > 0
    #         avg = avg / total_acres
    #         return Math.round(avg)
    #     else
    #         return ""


    # Ensures that the min pop is set lower than the max pop
    #   - set_low: if true, we'll move the low population down.
    #               if false, we'll move the high population up
    checkPopMinMax: (set_low = true) =>
        min = parseInt @scope.rx.solver_variables.min_pop
        max = parseInt @scope.rx.solver_variables.max_pop
        if min > max
            if set_low
                @scope.rx.solver_variables.min_pop = max - 1
            else
                @scope.rx.solver_variables.max_pop = min + 1


    # Ensures that the min pop diff is set lower than the max pop diff
    #   - set_low: if true, we'll move the low population down.
    #               if false, we'll move the high population up
    checkPopDiffMinMax: (set_low = true) =>
        min = parseInt @scope.rx.solver_variables.min_pop_diff
        max = parseInt @scope.rx.solver_variables.max_pop_diff

        pdiffs = @scope.options.pop_diffs
        if min > max
            # logic works this way:
            #
            #   - if we're adjusting the low value,
            #   - find the index in the list of pop diff options that the max
            #     is set at
            #   - if the max is set to the zeroeth item, the min pop diff can't be
            #     lower so, we set it to the zeroeth item as well.
            #   - if the max wasn't the zeroeth item, the min pop diff will be
            #     whatever the next lowest item is from the max
            #
            # Works essentially the opposite if you're adjusting the high value
            if set_low
                ind = pdiffs.indexOf max
                if ind is 0
                    min_ind = 0
                else
                    min_ind = ind - 1

                @scope.rx.solver_variables.min_pop_diff = pdiffs[min_ind]
            else
                ind = pdiffs.indexOf min
                if ind is (pdiffs.length - 1)
                    max_ind = ind
                else
                    max_ind = ind + 1

                @scope.rx.solver_variables.max_pop_diff = pdiffs[max_ind]


    # Toggles the table view "dialog"
    toggleTable: () =>
        @scope.$parent.show_fullpage = not @scope.$parent.show_fullpage
        if @scope.$parent.show_fullpage
            @state.go('grower.planting-rx.prescription.table', null, location: false)
        else
            @state.go('grower.planting-rx.prescription', null, location: false)


    # Calculates summary data for the selected hybrids. This includes
    # acres the brand is planted on, units, average population this
    # brand is planted at,
    # acres this brand is on, percent of total acres this brand is on, units
    calculateSummaries: () =>

        total_acres = 0
        ref_pct = null

        active_selections = []
        for sel in @scope.rx.planting_selections when sel.active
            active_selections.push sel

        for selection in active_selections
            mypops = _.filter @scope.rx.populations, { temp_hybrids_id: selection.brand.id }
            seeds = 0
            acres = 0

            # sum acres and seeds, and calculate units
            for pop in mypops
                ac = parseFloat(pop.acres)
                myseeds = pop.temp_population * ac
                seeds += myseeds
                acres += ac
                # TODO: units shouldn't be calculated in the summary logic
                pop.units = (myseeds / @scope.rx.seeds_per_bag).toFixed(1)

            total_acres += acres


            if selection.primary and @scope.rx.refuge?.active
                ref_pct = selection.brand.ref_pct ? 20

                # TODO: make this behave for multi-hybrid scenarios!
                if active_selections.length is 1
                    area_sub = (ref_pct * 0.5) / 100
                    acres = acres - (acres * area_sub)

            if seeds > 0
                acres = acres.toFixed(1)
                avg = Math.round(seeds / acres)
            else
                avg = 0

            selection.units = Math.ceil(seeds / @scope.rx.seeds_per_bag)
            selection.acres = acres
            selection.avg_pop = avg

        # Now that we have the units for each polygon, calculate truth strip
        # units too. This really needs to go somewhere else, but it can't yet.
        for strip in @scope.rx.truth_strips
            strip.units = 0
            polys = @rxLayer.getStripPolygons(strip)
            continue if not polys or polys.length is 0
            # stupid type casting because javascript really does care about
            # types even though it pretends it doesn't
            strip.units += parseFloat(poly.units) for poly in polys
            strip.units = strip.units.toFixed(1)

        for selection in active_selections
            perc = ((selection.acres / total_acres) * 100)
            selection.perc_acres = perc.toFixed(1)

        if @scope.rx.refuge?.active
            refuge = @scope.rx.refuge
            refuge.acres = (total_acres * (ref_pct / 100)).toFixed(1)
            refuge.perc_acres = ref_pct
            refuge.avg_pop = @scope.averagePop()
            refuge.units = Math.ceil((refuge.avg_pop * refuge.acres) / @scope.rx.seeds_per_bag)
